module.exports = __webpack_public_path__ + "img/back-impact.815f7091.webp";